import { useState, useEffect } from 'react';

const API_URL = window.__BACKEND_URL;

/**
 * Hook to fetch legal documents for a specific link target
 * @param {string} target - Link target (footer, signup, login, oauth, etc.)
 * @returns {{ documents: Array, loading: boolean, error: string|null }}
 */
export function useLegalLinks(target) {
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchLinks = async () => {
      try {
        setLoading(true);
        const res = await fetch(`${API_URL}/api/public/legal/links/${target}`);
        if (res.ok) {
          const data = await res.json();
          setDocuments(data.documents || []);
        } else {
          setError('Failed to load legal links');
        }
      } catch (err) {
        console.error(`Error fetching legal links for ${target}:`, err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    if (target) {
      fetchLinks();
    }
  }, [target]);

  return { documents, loading, error };
}

/**
 * Get legal document URL by slug
 * @param {string} slug - Document slug
 * @returns {string} Full URL to legal document
 */
export function getLegalUrl(slug) {
  return `/legal/${slug}`;
}

/**
 * Common legal document slugs for reference
 */
export const LEGAL_SLUGS = {
  PRIVACY: 'privacy-policy',
  TERMS: 'terms-of-service',
  COOKIE: 'cookie-policy',
  AUTOPILOT: 'autopilot-safety',
  AFFILIATE: 'affiliate-terms',
  DATA_PROCESSING: 'data-processing'
};
